// @flow

import * as React from 'react';
import { createFragmentContainer, graphql } from 'react-relay/compat';
import JobEvent from '../JobEvent';
import type { JobEventAssigned_event } from './__generated__/JobEventAssigned_event.graphql';

type Props = {
  event: JobEventAssigned_event,
  previousTimestamp: ?string
};

function JobEventAssigned({ event, previousTimestamp }: Props) {
  return (
    <JobEvent timestamp={event.timestamp} previousTimestamp={previousTimestamp}>
      <JobEvent.Label>
        {/* I don’t love how this reads. Ideally if the agent "assigns" to the agent then this is */}
        {/* the best place for us to show some detail about the assigned agent. */}
        Dispatcher Assigned Job
      </JobEvent.Label>
    </JobEvent>
  );
}

export default createFragmentContainer(JobEventAssigned, {
  event: graphql`
    fragment JobEventAssigned_event on JobEvent {
      ... on JobEvent {
        timestamp
      }
    }
  `
});

